import { render, staticRenderFns } from "./FooterTab.vue?vue&type=template&id=1f2fdf02&scoped=true"
import script from "./FooterTab.vue?vue&type=script&lang=js"
export * from "./FooterTab.vue?vue&type=script&lang=js"
import style0 from "./FooterTab.vue?vue&type=style&index=0&id=1f2fdf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fdf02",
  null
  
)

export default component.exports